import _ from "lodash";
import { getContentFullArray } from "./SimpleArrayOfValues";
import LabelValueContainer from "./LabelValueContainer";
import DateAndValueArray from "./DateAndValueArray";
import { Typography } from "@material-ui/core";
import YesNoOrChildren from "./YesNoOrChildren";

const DateAndValueArrayContainer = ({
    switchValue,
    array,
    label,
    translationKey,
    style,
    skipSeparator,
    getValue,
    yearOnly,
    indent,
    suffix,
}) => {
    const contentFullArray = getContentFullArray(array);
    return (
        <YesNoOrChildren
            {...{
                label,
                switchValue,
                isChildrenVisible: !_.isEmpty(contentFullArray),
                style,
                indent,
            }}
        >
            <LabelValueContainer
                {...{
                    labelComponent: (
                        <Typography style={{ fontWeight: indent ? "inherit" : "bold" }}>{label}</Typography>
                    ),
                    valueComponent: (
                        <DateAndValueArray
                            {...{
                                contentFullArray,
                                translationKey,
                                getValue,
                                yearOnly,
                                suffix,
                            }}
                        />
                    ),
                    style,
                    skipSeparator,
                    indent,
                }}
            />
        </YesNoOrChildren>
    );
};

export default DateAndValueArrayContainer;
